module.exports = __webpack_public_path__ + "static/media/papercurve-approval-seal.0bc95695.svg";